var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 16.6c.4.5 1.2.5 1.6 0l6-6.3c.5-.5 0-1.3-.8-1.3h-4s.2-4.6 0-7c-.1-1.1-.9-2-2-2s-1.9.9-2 2c-.2 2.3 0 7 0 7H6c-.8 0-1.3.8-.8 1.4l6 6.2zM19 19H5c-1.1 0-2 .9-2 2 0 .6.4 1 1 1h16c.6 0 1-.4 1-1 0-1.1-.9-2-2-2z",
    fill: "#ffffff",
    className: "fill-000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.0e2cb56c43d6463c47b49663b7855334.svg";
export { ForwardRef as ReactComponent };